/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc ダイアログ関連ユーティリティ
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
import Vue from 'vue'
import FcSurveyDialog from '@/components/chatWindow/dialog/FcSurveyDialog'
import {
  MessageBox
} from 'element-ui'

const FcSurveyDialogConponent = Vue.extend(FcSurveyDialog)

let fcSurveyDialogInstance = null

export default new class {
  /**
   * エラーダイアログを表示します。
   * @param  {String}   errorCode エラーコード
   * @param  {Function} okFunc
   */
  showErrorDialog(errorCode, okFunc) {
    if (this.App.visibledChatWindow) {
      MessageBox.alert(Vue.prototype.$t('エラーが発生しました。\n現在チャットをご利用になれません。\n（エラーコード：{errorCode}）', {
          errorCode: errorCode
        }), {
          showClose: false
        })
        .then(_ => {
          if (okFunc != null) {
            okFunc()
          }
        })
    }
  }
  /**
   * 確認ダイアログを表示します。
   * @param  {String}   message メッセージ
   * @param  {Function} okFunc
   */
  showInfoDialog(message, okFunc) {
    if (this.App.visibledChatWindow) {
      MessageBox.alert(message, {
          showClose: false
        })
        .then(_ => {
          if (okFunc != null) {
            okFunc()
          }
        })
    }
  }
  /**
   * 確認ダイアログを表示します。
   * @param  {String}   message メッセージ
   * @param  {Function} okFunc
   * @param  {Function} cancelFunc
   */
  showConfirmDialog(message, okFunc, cancelFunc) {
    if (this.App.visibledChatWindow) {
      MessageBox.confirm(message, {
          showClose: false
        })
        .then(_ => {
          if (okFunc != null) {
            okFunc()
          }
        })
        .catch(_ => {
          if (cancelFunc != null) {
            cancelFunc()
          }
        })
    }
  }
  /**
   * オープン中のダイアログを閉じます。
   */
  close() {
    try {
      MessageBox.close()
    } catch (error) {
      // 一度もMessageBoxを使用していない状態でエラーとなる不具合があるため
      // エラーを握りつぶす
    }
  }

  /**
   * アンケート画面を表示します。
   * @param  {String} callSpecificKey 対象コール特定キー
   * @param  {Function} closeCallbackFunc ダイアログを閉じる際実行されるコールバックファンクション
   * @param  {String} closeButtonLabel 終了ボタンのラベル
   */
  showFcSurveyDialog(callSpecificKey, closeCallbackFunc, closeButtonLabel) {
    if (fcSurveyDialogInstance == null) {
      fcSurveyDialogInstance = new FcSurveyDialogConponent({
        el: document.createElement('div')
      })
      document.body.appendChild(fcSurveyDialogInstance.$el)
    }
    fcSurveyDialogInstance.init(callSpecificKey, closeCallbackFunc, closeButtonLabel)
  }
}()



// WEBPACK FOOTER //
// ./src/utils/DialogUtil.js